import React, {useState, useEffect} from 'react'
import ProfileCard from '../components/ProfileCard'
import ReserveList from '../components/reservas/ReserveList';

export default function Profile() {
const [user, setUser] = useState(null)
  useEffect(() => {
    const stored = localStorage.getItem('usuario');
    if (stored) setUser(JSON.parse(stored));
  }, []);

 // console.log(user)
  return (
    <div className='min-h-screen pt-20'>
        <div>
            <ProfileCard/>
            {user && 
            <ReserveList user={user}/>
            }
        </div>

    </div>
  )
}
